export default __webpack_public_path__ + "static/media/logo_menu.c1e4859e.png";